import React from 'react';
import '../assets/ui/alert-dot.scss'

const AlertDot = () => {
  return (
    <div className='alert-dot'></div>
  );
};

export default AlertDot;